var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{directives:[{name:"smooth-scroll",rawName:"v-smooth-scroll",value:({
    duration: 1000,
    offset: -110,
    container: '#scroll_content',
  }),expression:"{\n    duration: 1000,\n    offset: -110,\n    container: '#scroll_content',\n  }"}],staticClass:"nav-link bold",attrs:{"href":_vm.anchorId}},[_vm._v(" "+_vm._s(_vm.label)+" "),_vm._t("icon"),(_vm.notification > -1)?_c('Counter',{attrs:{"value":_vm.notification,"size":"small"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }